import '../assets/NcAppNavigationList-CLLHyHIn.css';
import { createElementBlock, openBlock, renderSlot } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcAppNavigationList"
};
const _hoisted_1 = { class: "app-navigation-list" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("ul", _hoisted_1, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ]);
}
const NcAppNavigationList = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-57437e4a"]]);
export {
  NcAppNavigationList as N
};
//# sourceMappingURL=NcAppNavigationList-DX_Yo23V.mjs.map
